import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Axios from 'axios';
import usePagination from '../../hooks/usePagination';
import { fetchActiveLabs } from '../ApiHandler/labFunctions';

const API_URL = process.env.REACT_APP_API_URL;

const ViewStudents = ({ role, showAllEntities }) => {
    const [students, setStudents] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    
    // Filters
    const [filterState, setFilterState] = useState("");
    const [filterDistrict, setFilterDistrict] = useState("");
    const [filterSchool, setFilterSchool] = useState("");
    const [filterClass, setFilterClass] = useState("");
    const [filterLab, setFilterLab] = useState("");
    const [filterKendra, setFilterKendra] = useState("");
    const [labs, setLabs] = useState([]);
    const [kendras, setKendras] = useState([]);

    const states = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
        "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
        "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
        "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
    ];

    useEffect(() => {
        fetchStudents();
        fetchActiveLabs(setLabs);
    }, [showAllEntities, role]);

    useEffect(() => {
        if (filterLab) {
            import('../ApiHandler/kendraFunctions').then(({ fetchKendras }) => {
                fetchKendras(filterLab, setKendras);
            });
        } else {
            setKendras([]);
            setFilterKendra("");
        }
    }, [filterLab]);

    const fetchStudents = async () => {
        try {
            const response = await Axios.get(`${API_URL}/students/fetchStudents`, {
                headers: {
                    Authorization: localStorage.getItem('token')
                }
            });
            if (response.data.status === 'success') {
                setStudents(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching students:', error);
            toast.error('Failed to fetch students!');
        }
    };

    const handleDeleteStudent = async (id) => {
        if (window.confirm('Are you sure you want to delete this student?')) {
            try {
                const response = await Axios.delete(`${API_URL}/students/delete/${id}`, {
                    headers: { Authorization: localStorage.getItem('token') }
                });
                if (response.data.status === 'success') {
                    toast.success('Student deleted successfully');
                    fetchStudents();
                } else {
                    toast.error(response.data.message || 'Failed to delete student');
                }
            } catch (error) {
                console.error('Error deleting student:', error);
                toast.error('Failed to delete student');
            }
        }
    };

    const downloadExcel = (filtered = false) => {
        let url = `${API_URL}/students/download-excel`;
        if (filtered) {
            const params = new URLSearchParams();
            if (filterState) params.append('state', filterState);
            if (filterDistrict) params.append('district', filterDistrict);
            if (filterSchool) params.append('schoolName', filterSchool);
            if (filterClass) params.append('studentClass', filterClass);
            if (filterLab) params.append('lab_id', filterLab);
            if (filterKendra) params.append('kendra_id', filterKendra);
            url += `?${params.toString()}`;
        }
        
        Axios.get(url, {
            headers: { Authorization: localStorage.getItem('token') },
            responseType: 'blob'
        }).then(response => {
            const href = window.URL.createObjectURL(response.data);
            const anchorElement = document.createElement('a');
            anchorElement.href = href;
            anchorElement.download = 'students.xlsx';
            document.body.appendChild(anchorElement);
            anchorElement.click();
            document.body.removeChild(anchorElement);
            window.URL.revokeObjectURL(href);
        }).catch(err => {
            console.error('Error downloading excel:', err);
            toast.error('Failed to download excel');
        });
    };

    const filteredStudents = students.filter(student => {
        const matchesSearch = 
            student.first_name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
            student.last_name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
            student.school_name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
            student.district_name?.toLowerCase()?.includes(searchQuery.toLowerCase());
            
        const matchesState = filterState ? student.state === filterState : true; // fix state column
        const matchesDistrict = filterDistrict ? student.district_name?.toLowerCase()?.includes(filterDistrict.toLowerCase()) : true;
        const matchesSchool = filterSchool ? student.school_name?.toLowerCase()?.includes(filterSchool.toLowerCase()) : true;
        const matchesClass = filterClass ? student.student_class === filterClass : true; // if student_class exists
        const matchesLab = filterLab ? String(student.lab_id) === String(filterLab) : true;
        const matchesKendra = filterKendra ? String(student.kendra_id) === String(filterKendra) : true;
        
        return matchesSearch && matchesState && matchesDistrict && matchesSchool && matchesClass && matchesLab && matchesKendra;
    });

    const {
        currentEntries,
        currentPage,
        totalPages,
        handlePrevPage,
        handleNextPage,
    } = usePagination(filteredStudents, 10);

    return (
        <div className="table-data" style={{ marginTop: '20px' }}>
            <div className="order">
                <div className="head" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <h3><i className='bx bx-notepad' style={{color:'#6C5CE7'}}></i> Registered Students</h3>
                        <span style={{ backgroundColor: '#6C5CE7', color: 'white', padding: '3px 10px', borderRadius: '15px', fontSize: '12px', fontWeight: 'bold' }}>{filteredStudents.length}</span>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <div className="search-container" style={{ position: 'relative' }}>
                            <i className="bx bx-search" style={{ position: 'absolute', left: '10px', top: '10px', color: '#999' }}></i>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search..."
                                style={{ padding: '8px 10px 8px 30px', borderRadius: '20px', border: '1px solid #ddd', outline: 'none' }}
                            />
                        </div>
                        <button onClick={() => downloadExcel(false)} style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <i className='bx bxs-file-export'></i> Excel
                        </button>
                    </div>
                </div>
                
                {/* Filters Section */}
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '14px', color: '#555', fontWeight: '600' }}><i className='bx bx-filter-alt'></i> FILTERS:</span>
                    
                    <select value={filterState} onChange={e => setFilterState(e.target.value)} style={filterInputStyle}>
                        <option value="">All States</option>
                        {states.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                    
                    <input type="text" placeholder="District" value={filterDistrict} onChange={e => setFilterDistrict(e.target.value)} style={filterInputStyle} />
                    
                    <input type="text" placeholder="School Name" value={filterSchool} onChange={e => setFilterSchool(e.target.value)} style={filterInputStyle} />
                    
                    <select value={filterClass} onChange={e => setFilterClass(e.target.value)} style={filterInputStyle}>
                        <option value="">All Classes</option>
                        <option value="9">Class 9</option>
                        <option value="10">Class 10</option>
                        <option value="11">Class 11</option>
                        <option value="12">Class 12</option>
                        <option value="Undergraduate">Undergraduate</option>
                        <option value="Postgraduate">Postgraduate</option>
                        <option value="other">Other</option>
                    </select>
                    
                    <select value={filterLab} onChange={e => setFilterLab(e.target.value)} style={filterInputStyle}>
                        <option value="">All Labs</option>
                        {labs.map(lab => <option key={lab.id} value={lab.id}>{lab.lab_name}</option>)}
                    </select>

                    <select value={filterKendra} onChange={e => setFilterKendra(e.target.value)} style={{...filterInputStyle, display: kendras.length > 0 ? 'inline-block' : 'none'}}>
                        <option value="">All Kendras</option>
                        {kendras.map(kendra => <option key={kendra.id} value={kendra.id}>{kendra.kendra_name}</option>)}
                    </select>
                    
                    <button onClick={() => downloadExcel(true)} style={{ backgroundColor: '#10b981', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px' }}>
                        <i className='bx bxs-download'></i> Download Filtered Excel
                    </button>
                </div>

                <div className="artifacts-table-view" style={{ overflowX: 'auto' }}>
                    <table className="artifacts-table" style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
                        <thead style={{ backgroundColor: '#f9f9f9', textAlign: 'left' }}>
                            <tr>
                                <th style={thStyle}>#</th>
                                <th style={thStyle}>NAME</th>
                                <th style={thStyle}>FATHER</th>
                                <th style={thStyle}>KENDRA</th>
                                <th style={thStyle}>CLASS</th>
                                <th style={thStyle}>SCHOOL</th>
                                <th style={thStyle}>STATE</th>
                                <th style={thStyle}>DISTRICT</th>
                                <th style={thStyle}>MOBILE</th>
                                <th style={{ ...thStyle, textAlign: 'center' }}>ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentEntries.length === 0 ? (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>No students found matching your criteria.</td>
                                </tr>
                            ) : (
                                currentEntries.map((student, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                        <td style={tdStyle}>{student.id}</td>
                                        <td style={tdStyle}>
                                            <div style={{ fontWeight: '600', color: '#333' }}>{student.first_name} {student.last_name}</div>
                                        </td>
                                        <td style={tdStyle}>{student.father_name || 'N/A'}</td>
                                        <td style={tdStyle}>{student.kendra_name || 'N/A'}</td>
                                        <td style={tdStyle}>{student.student_class || 'N/A'}</td>
                                        <td style={tdStyle}>{student.school_name || 'N/A'}</td>
                                        <td style={tdStyle}>{student.state || 'N/A'}</td>
                                        <td style={tdStyle}>{student.district || 'N/A'}</td>
                                        <td style={tdStyle}>{student.mobile_number || 'N/A'}</td>
                                        <td style={{ ...tdStyle, display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
                                            <a
                                                href="# "
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    localStorage.setItem('studentToEdit', JSON.stringify(student));
                                                    localStorage.setItem('activeOption', 'studentRegistration');
                                                    localStorage.setItem('activeSection', 'studentRegistration');
                                                    window.location.reload();
                                                }}
                                                style={{ color: '#fff', background: '#6C5CE7', padding: '5px 10px', borderRadius: '4px', textDecoration: 'none', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '3px' }}
                                            >
                                                <i className='bx bx-edit'></i> Edit
                                            </a>
                                            <a
                                                href="# "
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleDeleteStudent(student.id);
                                                }}
                                                style={{ color: '#fff', background: '#e74c3c', padding: '5px 10px', borderRadius: '4px', textDecoration: 'none', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '3px' }}
                                            >
                                                <i className='bx bx-trash'></i> Delete
                                            </a>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
                    <button onClick={handlePrevPage} disabled={currentPage === 1} style={pageBtnStyle}>
                        Previous
                    </button>
                    <span style={{ fontSize: '14px', color: '#555' }}>
                        Page {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </span>
                    <button onClick={handleNextPage} disabled={currentPage === totalPages || totalPages === 0} style={pageBtnStyle}>
                        Next
                    </button>
                </div>

                <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #6C5CE7', fontSize: '13px', color: '#555' }}>
                    <i className='bx bx-shield-quarter' style={{ marginRight: '8px', color: '#6C5CE7' }}></i>
                    <strong>Role-Based Access:</strong> To ensure data privacy, Teachers can only view records mapped to their assigned Lab or School, or records they have personally added. District Officers can view all records within their assigned District. Admin has global access.
                </div>
            </div>
        </div>
    );
};

const filterInputStyle = {
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '20px',
    outline: 'none',
    fontSize: '13px',
    minWidth: '130px'
};

const thStyle = {
    padding: '12px 15px',
    color: '#666',
    fontWeight: '600',
    fontSize: '13px',
    textTransform: 'uppercase'
};

const tdStyle = {
    padding: '12px 15px',
    color: '#444',
    fontSize: '14px'
};

const pageBtnStyle = {
    padding: '6px 12px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    cursor: 'pointer',
    color: '#333'
};

export default ViewStudents;
